var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-item-component"},[_c('a',{on:{"click":function($event){return _vm.anchorHashCheck(_vm.item.anchor)}}},[_vm._v("\n  "+_vm._s(_vm.item.name)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }